const BRAND_GREEN = "#014339";
const MUTED = "#6b7a6b";
const CHIP_BORDER = "#c0c4c0";

const styles = {
  dashed: {
    width: 0,
    height: 10,
    borderLeft: `1px dashed ${CHIP_BORDER}`,
  },

  dayContainer: {
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
    background: "none",
    border: `1px dashed ${CHIP_BORDER}`,
    borderRadius: "12px",
    padding: "2px 8px",
    fontSize: 11,
    color: MUTED,
    cursor: "pointer",
    fontFamily: "inherit",
    whiteSpace: "nowrap",
    transition: "all 0.15s ease",
    "&:hover": {
      borderColor: BRAND_GREEN,
      color: BRAND_GREEN,
    },
  },
  label: (selected: boolean) => ({
    display: "block",
    width: "100%",
    padding: "6px 12px",
    background: selected ? "#f0f4f0" : "transparent",
    border: "none",
    textAlign: "left",
    fontSize: 12,
    color: selected ? BRAND_GREEN : "#3a3a3a",
    fontWeight: selected ? 600 : 400,
    cursor: "pointer",
    fontFamily: "inherit",
    "&:hover": {
      background: selected ? "#f0f4f0" : "#f7f9f7",
    },
  }),
  businessText: {
    position: "absolute",
    left: "calc(100% + 8px)",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: 11,
    fontStyle: "italic",
    color: MUTED,
    fontFamily: "inherit",
    whiteSpace: "nowrap",
    pointerEvents: "none",
  },
};

export default styles;
